import React from 'react';
import './MovementItem.css';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
//utils
import { formatDate } from '../../utils/utils';

const MovementItem = ({ action, transaction_type, tokens_obtained, tokens_spent, created_at }) => {
  const isPositive = (action === 'purchase' || action === 'gain');
  let tokenAmount = isPositive ? tokens_obtained : tokens_spent;
  const currentLanguage = i18n.language;
  tokenAmount = Number(tokenAmount).toLocaleString(currentLanguage === 'es' ? 'es-MX' : 'en-US');
  const { t } = useTranslation();

  const handleDescription = () => {
    switch (transaction_type) {
      case 'purchase':
          return t('payments.method.typesMovest.purchase');
      case 'service_consumption':
          return t('payments.method.typesMovest.service_consumption');
      case 'courtesy_tokens':
          return t('payments.method.typesMovest.courtesy_tokens');
      case 'follow_on_social_networks':
          return t('payments.method.typesMovest.follow_on_social_networks');
      case 'service_provision':
          return t('payments.method.typesMovest.service_provision');
      case 'invitation':
          return t('payments.method.typesMovest.invitation'); 
      case 'support_assist_refund':
          return t('payments.method.typesMovest.support_assist_refund');
      case 'support_assist_penalty':
          return t('payments.method.typesMovest.support_assist_penalty');
      default:
          return transaction_type;
      }
  };
  
  return (
      <div className="movement-item">
          <div className="movement-info">
              <div className={`movement-date ${isPositive ? 'positive' : 'negative'}`}>
                {formatDate(created_at, currentLanguage === 'es' ? 'es-MX' : 'en-US')}
              </div>
              <div className="movement-description">
                {handleDescription()}
              </div>
          </div>
          <div className={`movement-amount ${isPositive ? 'positive' : 'negative'}`}>
              {tokenAmount}
          </div>
      </div>
  );
};

export default MovementItem;
